/**
 * 画像をアスペクト比を維持しながら指定サイズに収める
 */
export function fitImage(
  img: Phaser.GameObjects.Image,
  maxWidth: number,
  maxHeight: number,
): void {
  const scaleX = maxWidth / img.width;
  const scaleY = maxHeight / img.height;
  img.setScale(Math.min(scaleX, scaleY));
}
